// extracted by mini-css-extract-plugin
module.exports = {"nombre":"Dog_Detail_nombre__29YZU","imagen":"Dog_Detail_imagen__1Qg_y","peso":"Dog_Detail_peso__w2LmV","volver":"Dog_Detail_volver__1jgGJ","General":"Dog_Detail_General__2kFUr"};